import { Link, useParams } from '@tanstack/react-router';
import { useSnapshot } from 'valtio';
import { Action } from '~/authorizations';
import { useActionPermission } from '~/authorizations/useActionPermission';
import { EXPORT_TAB_ID } from '../../exportTabIds';
import store from '../store';

/** "Click here to start download." link to the exports page, for roles that can download data. */
export default function StartDownload() {
  const { projectId } = useParams({ strict: false }) as { projectId: string };
  const { isFullUtilitiesExperienceEnabled } = useSnapshot(store) as typeof store;
  const canDownloadData = useActionPermission(Action.DownloadData);
  if (!isFullUtilitiesExperienceEnabled || !canDownloadData) {
    return null;
  }
  const link = `/projects/${projectId}/${EXPORT_TAB_ID}`;
  return (
    <>
      Click{' '}
      <Link to={link} className="text-blue-50 underline hover:text-blue-60">
        here
      </Link>{' '}
      to start download.
    </>
  );
}
